import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "@ts-digital/vrc";

const ReloadModal = ({reloadModal, setReloadModal, reloadDetail}) => {

  return reloadModal && (
    <Modal
      visible={reloadModal}
      onClose={e => {
        setReloadModal(false);
      }}
      type="primary"
      outsideClosable={false}
      footer={
        <div className="cashFlowModal-footer">
          <Button
            kind="secondary"
            onClick={() => {              
              setReloadModal(false);
            }
            }
            size="medium"
          >
            <FormattedMessage id="actions.cancel" />
          </Button>
          <Button
            onClick={() => {              
              reloadDetail();
              setReloadModal(false);
            }}
            size="medium"
          >
            <FormattedMessage id="actions.confirm" />
          </Button>
        </div>
      }
    >
      <div>
        <div style={{ width: 500 }}>
          <FormattedMessage id="preCog.confirmModal1" />
          <br />
          <FormattedMessage id="preCog.confirmModal2" />
        </div>
      </div>
    </Modal>
  );
};

export default ReloadModal;
